import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const propTypes = {
  statements: PropTypes.array,
};

const StatementOfAccount = (props) => {
  const { statements } = props;

  return (
    <table className="table table--statement-of-account">
      <tbody>
        {statements.map((statement) => (
          <tr key={statement.id}>
            <td>
              <span>{statement.name}</span>
            </td>
            <td>
              <a href={`${API_HOST}/statement-of-account/${statement.id}/download`} rel="noopener noreferrer" target="_blank">
                <FormattedMessage id="selfservice.statementOfAccount.download" />
              </a>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

StatementOfAccount.propTypes = propTypes;

export default StatementOfAccount;
